import { render } from "./EyeTooltip.vue?vue&type=template&id=32a89840&scoped=true"
import script from "./EyeTooltip.vue?vue&type=script&lang=ts"
export * from "./EyeTooltip.vue?vue&type=script&lang=ts"

import "./EyeTooltip.vue?vue&type=style&index=0&id=32a89840&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32a89840"

export default script